import { toast } from "react-toastify"
import { useCallback } from "react"

export const useShowAlert = () => {
  const success = useCallback((letter) => {
    toast.success(`${letter}`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }, [])

  const error = useCallback((letter) => {
    toast.error(`${letter}`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      limit: 3
    })
  }, [])

  return { error, success }
}
